import { formatNumberWithSpaces } from "utils/formatNumberWithSpaces";
import { ImArrowUpRight2, ImArrowDownRight2 } from "react-icons/im";
import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "antd";

const { Meta } = Card;
import CardTitle from "components/CardTitle";
import CardLayout from "components/CardLayout";
import { FaReceipt } from "react-icons/fa6";

interface AnnualReceiptsProps {
  totalValueN1?: number | string;
  totalReturns?: number | string;
  totalValue?: number | string;
  percentage?: number | string;
  totalPayments?: number | string;
  currencyCode: ID;
  decimalPlaces: number;
  loading: boolean;
}

export default function AnnualReceipts(props: AnnualReceiptsProps): React.ReactElement {
  const {
    currencyCode,
    decimalPlaces,
    totalPayments,
    totalValueN1,
    totalValue,
    percentage,
    loading,
  } = props;

  const { t } = useTranslation();

  const formattedTotalValue = formatNumberWithSpaces(
    Number(totalValue ?? 0).toFixed(decimalPlaces),
  );
  const isPositivePercentage = percentage && typeof percentage === "number" && percentage > 0;

  const renderComparisonArrow = () => {
    if (isPositivePercentage) {
      return <ImArrowUpRight2 color="rgb(34, 140, 66)" size={13} style={{ marginRight: 2 }} />;
    }
    return <ImArrowDownRight2 color="rgb(201, 39, 40)" size={12} style={{ marginRight: 4 }} />;
  };

  return (
    <CardLayout
      className="receipts-card"
      loading={loading}
      tooltipText={t("Only validated documents are taken into account")}
      title={<CardTitle bold icon={<FaReceipt />} title={t("Receipts for the year")} />}
    >
      <Meta
        description={
          <>
            <Row gutter={[16, 0]} justify="start" className="card-values">
              <Col span={24} className="card-main-value">
                <strong>
                  {formattedTotalValue} {currencyCode}{" "}
                </strong>
                <span className="tva-type-name">TTC</span>
              </Col>
              <Col className="card-detail-row">
                <div className="card-detail-item">
                  <span className="card-detail-label">{t("Payments")}:</span>
                  <span className="card-detail-value">
                    {formatNumberWithSpaces(totalPayments) ?? 0}
                  </span>
                </div>
              </Col>
            </Row>

            {totalValueN1 && percentage && (
              <Row className="n-1-row">
                <Col className="n1-col">
                  <span className="n1-percentage">
                    {renderComparisonArrow()}
                    <strong
                      className={`n1-percentage-value-${
                        isPositivePercentage ? "positive" : "negative"
                      }`}
                    >
                      {percentage}%
                    </strong>
                  </span>
                  <div className="n1-comparison">
                    <span className="n-1-span">{t("N-1")} </span>
                    <strong>
                      {formatNumberWithSpaces(Number(totalValueN1)?.toFixed(decimalPlaces))}{" "}
                      {currencyCode} <span className="tva-type-name">TTC</span>
                    </strong>
                  </div>
                </Col>
              </Row>
            )}
          </>
        }
      />
    </CardLayout>
  );
}
